export default __webpack_public_path__ + "static/media/musicnote.3633a0b1.png";